import { memo } from 'react';

import ImageLoader from '../../molecules/Image';

const Address = memo(() => (
  <div>
    <div className='mb-2 font-14px white medium'>
      <ImageLoader alt='marketplace logo with name' height='38px' src='/images/logo.svg' width='140px' />
    </div>
    <div className='font-14px white'>#1502, HustleHub H1904, 4th Floor,</div>
    <div className='font-14px white'>19th Main Rd, 1st Sector, HSR Layout, Bengaluru, Karnataka 560102</div>
  </div>
));

Address.displayName = 'Address';

export default Address;
